import { type FC, useEffect, useRef, useState } from "react";

import { Input } from "@styled/input";

// Rename in place: the whole name starts selected. Enter or clicking away
// saves, Esc cancels; an empty name puts the default back.
export const ChatRowRename: FC<{
  name: string;
  onSave(name: string): void;
  onDone(): void;
}> = ({ name, onSave, onDone }) => {
  const [value, setValue] = useState(name);
  const ref = useRef<HTMLInputElement>(null);
  const finished = useRef(false);

  useEffect(() => ref.current?.select(), []);

  const finish = (save: boolean) => {
    if (finished.current) return;
    finished.current = true;
    if (save && value !== name) onSave(value);
    onDone();
  };

  return (
    <Input
      ref={ref}
      variant="sm"
      aria-label="Chat name"
      value={value}
      onChange={(event) => setValue(event.target.value)}
      onBlur={() => finish(true)}
      onKeyDown={(event) => {
        if (event.key === "Enter") finish(true);
        if (event.key === "Escape") {
          event.stopPropagation();
          finish(false);
        }
      }}
    />
  );
};
